import { render, staticRenderFns } from "./LoadingBox.vue?vue&type=template&id=f5549a54&scoped=true"
import script from "./LoadingBox.vue?vue&type=script&lang=js"
export * from "./LoadingBox.vue?vue&type=script&lang=js"
import style0 from "./LoadingBox.vue?vue&type=style&index=0&id=f5549a54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5549a54",
  null
  
)

export default component.exports